export const secureCookieOptions = { secure: true, sameSite: 'Lax' };
